import { render } from "./Header.vue?vue&type=template&id=60438c43&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=60438c43&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60438c43"],['__file',"src/assets/js/components/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60438c43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60438c43', __exports__)) {
    api.reload('60438c43', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=60438c43&scoped=true", () => {
    api.rerender('60438c43', render)
  })

}


export default __exports__